<template>
  <button class="fab" v-bind="$props" v-on="$listeners">
    <div class="fab__content">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 11V13H7.99997L13.5 18.5L12.08 19.92L4.15997 12L12.08 4.08L13.5 5.5L7.99997 11H20Z"
          fill="#F40009"
        />
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  name: "Fab",
};
</script>

<style lang="scss" scoped>
.fab {
  @include red-shadow;
  @include circle(48px);
  background: none;
  border: none;
  outline: none;
  overflow: hidden;
}
.fab__content {
  width: 100%;
  height: 100%;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: $size-font-1;
  color: $color-primary;
  background-color: $color-white;
  overflow: hidden;
  border: none;
}
</style>
